import templateUrl from "emun.order/parts/parts-order-details-lines.htm";

export default () => ({ templateUrl });
